<template>
    <div>
        <input type="text" v-model="value">
    </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,

      }
    },
    mounted() {
      jQuery(() => {
        $(this.$el).datetimepicker({
          format: 'YYYY-MM-DD',
          sideBySide: true,
        }).on('dp.change', function (e) {
          $input = $(e.target).find('input');
          $input[0].dispatchEvent(new Event('change'));
          this.value = e.target.value;
          return true;
        });;
      });
    },
  }
</script>
